import request from '@/config/axios';

/**
 * 平台管理端 — 商家入驻审核 API
 */

// 获取入驻申请分页
export function getApplyPage(params: any) {
  return request.get({ url: '/merchant/apply/page', params });
}

// 获取入驻申请详情
export function getApplyDetail(id: number) {
  return request.get({ url: '/merchant/apply/get', params: { id } });
}

// 新增入驻申请（平台运营代提交，进入待审核）
export function createApply(data: any) {
  return request.post({ url: '/merchant/apply/create', data });
}

// 审核入驻申请
// categoryCommissionRates：由详情页表格组装的 JSON 字符串，如 {"87":5.0}；运营界面不手写
export function auditApply(data: {
  id: number
  approved: boolean
  auditRemark?: string
  categoryCommissionRates?: string
}) {
  return request.post({ url: '/merchant/apply/audit', data })
}

// 重置商家登录密码（审核通过后，运营代商家重置）
export function resetApplyPassword(id: number, password: string) {
  return request.post({ url: '/merchant/apply/reset-password', params: { id, password } });
}
